export const roleAddPath = () => '/api/role/create';
export const roleUpdatePath = () => `/api/role/update`;
export const roleFindByIdPath = (id) => `/api/role/findById/${id}`;
export const roleFindAllPath = () => `/api/role/findAll`;
export const roleDeletePath = (id) => `/api/role/delete/${id}`;
export const actionsFindAllPath = () => `/api/role/findAllActions`;
export const roleFindAllDTOPath = () => `/api/role/findAllRolesDTO`;
export const roleFindAllPageablePath = (pageNumber, pageSize) =>
  `/api/role/findAll/${pageNumber}/${pageSize}`;
export const roleAddAndReturnRoleDTOPath = () =>
  '/api/role/createAndReturnRoleDTO';
export const rolefindAllHashMapListPath = () =>
  `/api/role/findAllRolesHashMapList`;
export const signetFindAllPageablePath = (pageNumber, pageSize) =>
  `/api/signet/findAll/${pageNumber}/${pageSize}`;
export const filterPageablePath = (pageNumber, pageSize) =>
  `/api/filter/${pageNumber}/${pageSize}`;
export const signetUpdateStatusPath = (signetId, statusName) =>
  `/api/signet/updateSignetStatus/${signetId}/${statusName}`;
export const signetUpdateStatePath = (id, signetState) =>
  `/api/signet/state/${id}/${signetState}`;
export const signetFindByIdStatusPath = (id) => `/api/signet/findSignet/${id}`;
export const signetExampleDownloadPath = () =>
  '/api/signetExample/downloadSignetExample';
export const signetExampleUploadPath = () => '/api/signetExample/upload';
export const userAddPath = () => '/api/user/create';
export const userUpdatePath = () => `/api/user/update`;
export const userFindByIdPath = (id) => `/api/user/findById/${id}`;
export const userFindAllPath = () => `/api/user/findAll`;
export const userFindAllPageablePath = (pageNumber, pageSize) =>
  `/api/user/findAll/${pageNumber}/${pageSize}`;
export const userDeletePath = (id) => `/api/user/delete/${id}`;
export const userDeactivatePath = (id) => `/api/user/deactivate/${id}`;
export const userActivatePath = (id) => `/api/user/activate/${id}`;
export const decisionAddPath = () => '/api/decision/create';
export const decisionUpdatePath = () => `/api/decision/update`;
export const decisionFindByIdPath = (id) => `/api/decision/findById/${id}`;
export const decisionFindByRequestIdPath = (id) =>
  `/api/decision/findByRequestId/${id}`;
export const decisionFindAllPath = () => `/api/decision/findAll`;
export const decisionFindAllPageablePath = (pageNumber, pageSize) =>
  `/api/decision/findAll/${pageNumber}/${pageSize}`;
export const decisionDeletePath = (id) => `/api/decision/delete/${id}`;
export const changeDecisionStatusPath = () =>
  `/api/decision/changeDecisionStatus`;

//SUBMISSION DATA SIGNET
export const submissionDataSignetAddPath = () =>
  '/api/submissionDataSignet/create';
export const submissionDataSignetUpdatePath = () =>
  '/api/submissionDataSignet/update';
export const submissionDataSignetFindByIdPath = (id) =>
  `/api/submissionDataSignet/findById/${id}`;
export const submissionDataSignetFindAllPath = () =>
  '/api/submissionDataSignet/findAll';
export const submissionDataSignetFindAllPageablePath = (pageNumber, pageSize) =>
  `/api/submissionDataSignet/findAll/${pageNumber}/${pageSize}`;
export const submissionDataSignetDeletePath = (id) =>
  `/api/submissionDataSignet/delete/${id}`;
export const submissionDataSignetAddWithAttachmentPath = () =>
  '/api/submissionDataSignet/createWithAttachment';
export const submissionDataSignetAddWithOneAttachmentPath = () =>
  '/api/submissionDataSignet/createWithOneAttachment';

//COMPLEMENT REQUEST APPROVAl
export const complementRequestApprovalAddPath = () =>
  '/api/complementRequestApproval/create';
export const complementRequestApprovalUpdatePath = () =>
  '/api/complementRequestApproval/update';
export const complementRequestApprovalFindPath = (
  complementRequestApprovalId
) => `/api/complementRequestApproval/findById/${complementRequestApprovalId}`;
export const complementRequestApprovalFindAllPath = () =>
  `/api/complementRequestApproval/findAll`;
export const complementRequestApprovalFindAllByRequestPath = (
  requestApprovalId
) =>
  `/api/complementRequestApproval/findByRequestApprovalId/${requestApprovalId}`;
export const complementRequestApprovalFindLastByRequestPath = (
  complementRequestApprovalId
) =>
  `/api/complementRequestApproval/findLastByRequestApprovalId/${complementRequestApprovalId}`;

export const decisionTypeAddPath = () => '/api/decisionType/create';
export const decisionTypeUpdatePath = () => '/api/decisionType/update';
export const decisionTypeFindAllPath = () => `/api/decisionType/findAll`;
export const decisionTypeFindByIdPath = (id) =>
  `/api/decisionType/findById/${id}`;
export const decisionTypeDeletePath = (id) => `/api/decisionType/delete/${id}`;
export const decisionTypeFindAllPageablePath = (pageNumber, pageSize) =>
  `/api/decisionType/findAll/${pageNumber}/${pageSize}`;
export const decisionTypeWithAttachmentAddPath = (type) =>
  `/api/decisionType/createDecisionTypeWithAttachment/${type}`;
export const decisionTypeAttachmentFindByDecisionTypePath = (decisionTypeId) =>
  `/api/decisionTypeAttachment/findByDecisionType/${decisionTypeId}`;

export const decisionTypeAttachmentUploadPath = (decisionTypeId) =>
  `/api/decisionTypeAttachment/upload/${decisionTypeId}`;
export const decisionTypeAttachmentFindByDecisionTypeNamePath = (
  decisionTypeName,
  controllerReference
) => `/api/${controllerReference}/findAttachment/${decisionTypeName}`;

export const decisionTypeAttachmentFindAllByDecisionTypeIdPath = (
  decisionTypeId
) => `/api/decisionTypeAttachment/findAllByDecisionTypeId/${decisionTypeId}`;
export const decisionTypeAttachmentFindAllPageablePath = (
  decisionTypeId,
  pageNumber,
  pageSize
) =>
  `/api/decisionTypeAttachment/findAll/${decisionTypeId}/${pageNumber}/${pageSize}`;
export const downloadDecisionTypeAttachmentPath = (uuidDocName) =>
  `/api/decisionTypeAttachment/downloadAttachment/${uuidDocName}`;
export const decisionAddWithAttachmentPath = (reqId) =>
  `/api/decision/createDecisionWithAttachment/${reqId}`;

//SUBMISSION DATA SIGNET DESTROYED
export const submissionDataSignetDestroyedUploadPath = (signetDestroyedId) =>
  `/api/submissionDataSignetDestroyed/upload/${signetDestroyedId}`;

export const submissionDataSignetDestroyedAddPath = () =>
  '/api/submissionDataSignetDestroyed/createSubmissionDataSignetDestroyed';
export const submissionDataSignetDestroyedFindBySubmissionDataSignetPath = (
  submissionDataSignetDestroyedId
) =>
  `/api/submissionDataSignetDestroyed/findBySubmissionDataSignet/${submissionDataSignetDestroyedId}`;

export const submissionDataSignetDestroyedFindByNamePath = (
  submissionDataSignetDestroyedName,
  controllerReference
) =>
  `/api/${controllerReference}/findAttachment/${submissionDataSignetDestroyedName}`;

export const submissionDataSignetDestroyedFindAllBySubmissionDataSignetIdPath =
  (submissionDataSignetDestroyedId) =>
    `/api/submissionDataSignetDestroyed/findAllBySubmissionDataSignetIdId/${submissionDataSignetDestroyedId}`;
export const submissionDataSignetDestroyedFindAllPageablePath = (
  submissionDataSignetDestroyedId,
  pageNumber,
  pageSize
) =>
  `/api/submissionDataSignetDestroyed/findAll/${submissionDataSignetDestroyedId}/${pageNumber}/${pageSize}`;
export const downloadSubmissionDataSignetDestroyedPath = (uuidDocName) =>
  `/api/submissionDataSignetDestroyed/downloadAttachment/${uuidDocName}`;

export const submissionDataSignetBySignetFindByIdPath = (signetId) =>
  `/api/submissionDataSignet/findBySignetId/${signetId}`;

//SUBMISSION DATA SIGNET LOOK

export const submissionDataSignetLookAddPath = () =>
  '/api/submissionDataSignetLook/createSubmissionDataSignetLook';
export const submissionDataSignetLookFindBySubmissionDataSignetPath = (
  submissionDataSignetLookId
) =>
  `/api/submissionDataSignetLook/findBySubmissionDataSignet/${submissionDataSignetLookId}`;

export const submissionDataSignetLookUploadPath = (
  submissionDataSignetLookId
) => `/api/submissionDataSignetLook/upload/${submissionDataSignetLookId}`;
export const submissionDataSignetLookFindByNamePath = (
  submissionDataSignetLookName,
  controllerReference
) =>
  `/api/${controllerReference}/findAttachment/${submissionDataSignetLookName}`;

export const submissionDataSignetLookFindAllBySubmissionDataSignetIdPath = (
  submissionDataSignetLookId
) =>
  `/api/submissionDataSignetLook/findAllBySubmissionDataSignetIdId/${submissionDataSignetLookId}`;
export const submissionDataSignetLookFindAllPageablePath = (
  submissionDataSignetLookId,
  pageNumber,
  pageSize
) =>
  `/api/submissionDataSignetLook/findAll/${submissionDataSignetLookId}/${pageNumber}/${pageSize}`;
export const downloadSubmissionDataSignetLookPath = (uuidDocName) =>
  `/api/submissionDataSignetLook/downloadAttachment/${uuidDocName}`;
export const getAllowedActionsPath = () => '/api/user/getAllowedActions';
export const getLoggedInUserPath = () => '/api/user/findLoggedInUser';

export const requestForSignetApprovalAddPath = () =>
  '/api/requestForSignetApproval/create';
export const requestForSignetApprovalUpdatePath = () =>
  `/api/requestForSignetApproval/update`;
export const requestForSignetApprovalFindByIdPath = (id) =>
  `/api/requestForSignetApproval/findById/${id}`;
export const requestForSignetApprovalFindAllPath = () =>
  `/api/requestForSignetApproval/findAll`;
export const requestForSignetApprovalFindAllPageablePath = (
  pageNumber,
  pageSize
) => `/api/requestForSignetApproval/findAll/${pageNumber}/${pageSize}`;
export const requestForSignetApprovalDeletePath = (id) =>
  `/api/requestForSignetApproval/delete/${id}`;
export const changeRequestForSignetApprovalStatusPath = (id, status) =>
  `/api/requestForSignetApproval/changeRequestForSignetApprovalStatus/${id}/${status}`;

export const requestForSignetApprovalAddProcessorRequestPath = (id) =>
  `/api/requestForSignetApproval/addProcessorRequestForSignetApproval/${id}`;

//AUTONOMOUS PROVINCE
export const autonomousProvinceFindAllPath = () =>
  '/api/autonomousProvince/findAll';

//PLACE
export const placeCreatePath = () => '/api/place/create';
export const placeUpdatePath = () => '/api/place/update';
export const placeFindAllPath = () => '/api/place/findAll';
export const placeFindAllPageablePath = (pageNumber, pageSize) =>
  `/api/place/findAll/${pageNumber}/${pageSize}`;
export const placeFindAllByAutonomousProvincePath = (autonomousProvinceId) =>
  `/api/place//findAllByAutonomousProvinceId/${autonomousProvinceId}`;
export const placeFindAllWithoutAutonomousProvincePath = () =>
  '/api/place/findAllWithoutAutonomousProvince';

//MUNICIPALITY
export const municipalityFindAllPageablePath = (pageNumber, pageSize) =>
  `/api/municipality/findAll/${pageNumber}/${pageSize}`;
export const municipalityFindAllPath = () => '/api/municipality/findAll';
export const municipalityFindAllByPlacePath = (placeId) =>
  `/api/municipality/findAllByPlaceId/${placeId}`;
export const municipalityAddPath = () => '/api/municipality/create';
export const municipalityUpdatePath = () => '/api/municipality/update';

//KJS
export const kjsFindAllPath = () => '/api/kjs/findAll';
export const kjsFindAllByInstitutionTypePath = (institutionTypeId) =>
  `/api/kjs/findAllByInstitutionTypeId/${institutionTypeId}`;
export const kjsFindAllByMunicipalityIdPath = (municipalityId) =>
  `/api/kjs/findAllByMunicipalityId/${municipalityId}`;
export const kjsFindAllPageablePath = (pageNumber, pageSize) =>
  `/api/kjs/findAll/${pageNumber}/${pageSize}`;
export const kjsSyncPath = () => `/api/kjs/sync`;
export const kjsUpdatePath = (signalActivation) =>
  `/api/kjs/update/${signalActivation}`;

//INSTITUTION_TYPE
export const institutionTypeFindAllPath = () => '/api/institutionType/findAll';

export const requestForSignetApprovalAttachmentFindAllPath = (
  requestForSignetApprovalId
) =>
  `/api/requestForSignetApprovalAttachment/findByRequestForSignetApproval/${requestForSignetApprovalId}`;

export const requestForSignetApprovalAttachmentDownloadPath = (uuidDocName) =>
  `/api/requestForSignetApprovalAttachment/downloadAttachment/${uuidDocName}`;

export const requestForSignetApprovalProposalSolutionDownloadPath = (
  requestForSignetApprovalId
) =>
  `/api/requestForSignetApproval/downloadProposalSolution/${requestForSignetApprovalId}`;
export const requestForSignetApprovalRequestDownloadPath = (
  requestForSignetApprovalId
) =>
  `/api/requestForSignetApproval/downloadRequest/${requestForSignetApprovalId}`;
export const userFindAllAllowedActionsPath = (id, controllerReference) =>
  `/api/${controllerReference}/allowedActions/${id}`;
export const createRequestForSignetApprovalReferenceNumberPath = (id) =>
  `/api/requestForSignetApproval/createRequestForSignetApprovalReferenceNumber/${id}`;

//DECISION ATTACHMENt

export const decisionAttachmentFindByDecisionPath = (decisionId) =>
  `/api/decisionAttachment/findByDecision/${decisionId}`;
export const downloadDecisionAttachmentPath = (decisionName) =>
  `/api/decisionAttachment/downloadAttachment/${decisionName}`;

export const changeDecisionStatusWithStatusPath = (id, status) =>
  `/api/decision/changeDecisionStatus/${id}/${status}`;

export const attachmentFindPath = (documentName, controllerReference) =>
  `/api/${controllerReference}/findAttachment/${documentName}`;

export const requestForSignetApprovalFindAllByProcessorPath = (
  pageNumber,
  pageSize
) =>
  `/api/requestForSignetApproval/findAllByProcessor/${pageNumber}/${pageSize}`;

export const requestForSignetApprovalFindAllByInspectorPath = (
  pageNumber,
  pageSize
) =>
  `/api/requestForSignetApproval/findAllByInspector/${pageNumber}/${pageSize}`;

export const requestForSignetApprovalFindAllByClientPath = (
  userId,
  pageNumber,
  pageSize
) =>
  `/api/requestForSignetApproval/findAllByClient/${userId}/${pageNumber}/${pageSize}`;

//COMPLEMENT SIGNET
export const complementSignetAddPath = () => '/api/complementSignet/create';
export const complementSignetUpdatePath = () => '/api/complementSignet/update';
export const complementSignetFindAllBySignetIdPath = (signetId) =>
  `/api/complementSignet/findBySignetId/${signetId}`;
export const complementSignetFindLastBySignetPath = (signetId) =>
  `/api/complementSignet/findLastBySignetId/${signetId}`;
export const signetAttachmentDownloadPath = (uuidDocName) =>
  `/api/signet/downloadAttachment/${uuidDocName}`;

export const signetFindAllByClientPath = (userId, pageNumber, pageSize) =>
  `/api/signet/findAllByClient/${userId}/${pageNumber}/${pageSize}`;

//REQUEST FOR SIGNET STATUS
export const requestForSignetStatusAddPath = () =>
  '/api/requestForSignetStatus/create';
export const requestForSignetStatusFindBySignetPath = (signetId) =>
  `/api/requestForSignetStatus/findBySignetId/${signetId}`;

export const requestForSignetStatusAttachmentFindByRequest = (
  requestForSignetStatusId
) =>
  `/api/requestForSignetStatusAttachment/findByRequestForSignetStatus/${requestForSignetStatusId}`;

export const requestForSignetStatusValidPath = (requestForSignetStatusId) =>
  `/api/requestForSignetStatus/validateSignet/${requestForSignetStatusId}`;

export const userProtenatAddPath = () => '/api/user/createUserProtenant';
export const signetExampleFindAllPageablePath = (pageNumber, pageSize) =>
  `/api/signetExample/findAll/${pageNumber}/${pageSize}`;

export const instructionDownloadPath = () =>
  '/api/signetExample/downloadInstruction';

export const kjsMunicipalityAddPath = () => '/api/kjsMunicipality/create';
export const kjsMunicipalityUpdatePath = () => '/api/kjsMunicipality/update';
export const kjsMunicipalityFindAllPath = () => '/api/kjsMunicipality/findAll';
export const kjsMunicipalityFindByIdPath = (id) =>
  `/api/kjsMunicipality/findById/${id}`;
export const kjsMunicipalityFindByKjsIdPath = (kjsId) =>
  `/api/kjsMunicipality/findByKjsId/${kjsId}`;
export const kjsMunicipalityFindByUserIdPath = (userId) =>
  `/api/kjsMunicipality/findByUserId/${userId}`;
export const sendDecisionToRobonPath = (id) => `/api/decision/send/${id}`;

export const usersByKJSMunicipalityPath = (kjsMunicipalityId) =>
  `/api/user/findAllByKJSMunicipality/${kjsMunicipalityId}`;
export const requestForSignetApprovalClientUpdatePath = () =>
  `/api/requestForSignetApproval/updateRequestClient`;
export const kjsMunicipalityFindAllPageablePath = (pageNumber, pageSize) =>
  `/api/kjsMunicipality/findAll/${pageNumber}/${pageSize}`;
